<template>
    <vue-scroll v-if="order">
        <div class="page-header">
            <h1>Order Details</h1>
        </div>

        <div
            class="order-nav pending mb-10"
            v-if="!order.is_closed && !getInvoicedStatus(order.statuses.data)"
        >
            <el-button
                :disabled="loadingPrevious"
                @click.prevent="navigatePlacedPendingOrder(false)"
                class="float-left"
                type="text"
            >
                <i class="mdi mdi-chevron-left" /> Previous Order
            </el-button>
            <el-button
                :disabled="loadingNext"
                @click.prevent="navigatePlacedPendingOrder()"
                class="float-right"
                type="text"
                >Next Order <i class="mdi mdi-chevron-right"
            /></el-button>
            <div class="clearfix"></div>
        </div>
        <div
            class="order-nav hub mb-10"
            v-if="
                !order.is_closed &&
                order.approval_status === 'approved' &&
                getInvoicedStatus(order.statuses.data) &&
                getInvoicedStatus(order.statuses.data).checked == true
            "
        >
            <el-button
                :disabled="loadingPrevious"
                @click.prevent="navigateOrder(false)"
                class="float-left"
                type="text"
            >
                <i class="mdi mdi-chevron-left" /> Previous Order
            </el-button>
            <el-button
                :disabled="loadingNext"
                @click.prevent="navigateOrder()"
                class="float-right"
                type="text"
                >Next Order <i class="mdi mdi-chevron-right"
            /></el-button>
            <div class="clearfix"></div>
        </div>
        <div class="order-nav closed mb-10" v-if="order.is_closed">
            <el-button
                :disabled="loadingPrevious"
                @click.prevent="navigateClosedOrder(false)"
                class="float-left"
                type="text"
            >
                <i class="mdi mdi-chevron-left" /> Previous Order
            </el-button>
            <el-button
                :disabled="loadingNext"
                @click.prevent="navigateClosedOrder()"
                class="float-right"
                type="text"
            >
                Next Order <i class="mdi mdi-chevron-right"
            /></el-button>
            <div class="clearfix"></div>
        </div>
        <el-alert
            class="mb-20 el-alert-content-center"
            v-if="order.approval_status === ApprovalStatus.REJECTED"
            title=""
            type="error"
            :closable="false"
        >
            <h4 class="m-0 text-center">
                <i class="mdi mdi-close" /> Order has been rejected.
            </h4>
        </el-alert>
        <el-alert
            class="mb-20 el-alert-content-center"
            v-if="order.is_billable_edit"
            title=""
            type="warning"
            :closable="false"
        >
            <h4 class="m-0 text-center">Order is placed on billable edit.</h4>
        </el-alert>
        <div>
            <div class="float-left" v-if="can(Permissions.EDIT_ORDER)">
                <template v-if="!order.is_closed">
                    <el-button
                        :disabled="approvalForm.busy"
                        :loading="
                            approvalForm.busy &&
                            approvalForm.approval_status ===
                                ApprovalStatus.APPROVED
                        "
                        @click="approval(true)"
                        icon="el-icon-check"
                        type="success"
                        v-if="!approvalDone && !order.is_billable_edit"
                        >Approve
                    </el-button>
                </template>
                <el-button
                    :loading="billableEditForm.busy"
                    @click="placeOnBillableEdit()"
                    type="warning"
                    v-if="
                        !order.is_billable_edit &&
                        can(Permissions.SET_BILLABLE_EDIT)
                    "
                    >Place Order on Billable Edit
                </el-button>
                <el-button
                    type="default"
                    icon="mdi mdi-download"
                    @click="downloadJobTicket()"
                    >Download Job Ticket
                </el-button>

                <el-button
                    type="default"
                    icon="mdi mdi-eye"
                    @click="viewInlineJobTicket()"
                    >View Job Ticket
                </el-button>
                <el-button
                    type="default"
                    icon="mdi mdi-folder-download"
                    :loading="downloadAllForm.busy"
                    @click="downloadAll()"
                    >Download All
                </el-button>
            </div>
            <div class="float-right mb-10" v-if="isApproved">
                <el-checkbox
                    title="Mark as Rush Processing"
                    v-model="rush_processing"
                    @change="onChangeRushProcessing"
                    border
                    label="Rush Processing"
                />
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="d-inline-block mt-10" v-if="order.previously_billable_edit">
            <el-alert
                :closable="false"
                show-icon
                title="This order was previously placed on billable edit."
                type="info"
            >
            </el-alert>
        </div>
        <el-row :gutter="20" class="mt-10">
            <el-col :md="14">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>Customer</span>
                        <el-tooltip
                            class="float-right"
                            :disabled="!order.logo_updated"
                            placement="bottom"
                        >
                            <div slot="content">
                                <i class="mdi mdi-pencil" /> Logo Updated
                            </div>
                            <el-button
                                v-if="order.community.has_logo"
                                style="padding: 3px 0"
                                type="text"
                                icon="mdi mdi-download"
                                @click="downloadLogo()"
                                >Download Logo
                            </el-button>
                        </el-tooltip>
                        <div class="clearfix"></div>
                    </div>
                    <div>{{ order.tenant.name }}</div>
                    <div>{{ formattedAddress }}</div>
                </el-card>
                <el-card class="box-card mt-10">
                    <div slot="header" class="clearfix">
                        <span>Order Breakdown</span>
                    </div>
                    <breakdown :order="order" />
                </el-card>
                <el-card class="box-card mt-10">
                    <div slot="header" class="clearfix">
                        <span>Shipping Info</span>
                    </div>
                    <span
                        :class="{
                            'text-error': order.custom_shipping_account_number
                        }"
                        >{{ shippingInfo }}</span
                    >
                </el-card>
                <el-card class="box-card mt-10">
                    <div slot="header" class="clearfix">
                        <span>Tracking</span>
                    </div>
                    <tracking :order="order" v-if="order" />
                </el-card>
                <el-card class="box-card mt-10">
                    <div slot="header" class="clearfix">
                        <span>Order Confirmation</span>
                    </div>
                    <span>
                        <el-button
                            @click="viewInvoice()"
                            icon="mdi mdi-eye"
                            round
                            type="primary"
                            v-if="
                                can(Permissions.VIEW_INVOICE) &&
                                !order.has_sage_invoice
                            "
                        >
                            View Order Confirmation
                        </el-button>
                        <el-button
                            @click="viewSageInvoice()"
                            icon="mdi mdi-eye"
                            round
                            type="primary"
                            v-if="
                                can(Permissions.VIEW_INVOICE) &&
                                order.has_sage_invoice
                            "
                        >
                            View Invoice
                        </el-button>
                        <invoice-payment-link
                            style="padding-top: 10px"
                            :community-id="order.community_id"
                            v-if="
                                !order.community.is_bill_to_account_only &&
                                order.has_sage_invoice
                            "
                        ></invoice-payment-link>
                    </span>
                    <el-button
                        @click="editInvoiceLines()"
                        class="el-button--corwin-green"
                        icon="mdi mdi-pencil"
                        round
                        type="success"
                        style="padding-top: 10px"
                        v-if="can(Permissions.EDIT_INVOICE)"
                    >
                        Edit Order Confirmation
                    </el-button>
                    <template
                        v-if="
                            order.is_closed &&
                            can(Permissions.MARK_INVOICE_AS_PAID)
                        "
                    >
                        <el-divider direction="vertical" />
                        <div class="mt-10">
                            Order Paid
                            <el-switch
                                :disabled="invoicePaidForm.busy"
                                @change="onChangeInvoicePaid"
                                v-model="invoicePaidForm.is_paid"
                            />
                        </div>
                    </template>
                </el-card>
                <el-card class="box-card mt-10">
                    <div slot="header" class="clearfix">
                        <span>Audit Log</span>
                    </div>
                    <audit-log :order="order" ref="auditLog" v-if="order" />
                </el-card>
            </el-col>
            <el-col :md="10">
                <edit-status
                    @success="updateAuditLogs()"
                    ref="editStatus"
                    :id="$route.params.id"
                />
                <div class="mt-10">
                    Assign to
                    <el-select
                        @change="onChangeAssignee"
                        filterable
                        style="width: auto"
                        v-model="assignForm.assignee_id"
                    >
                        <el-option :value="null" label="Unassigned" />
                        <el-option
                            :key="user.id"
                            :label="user.name"
                            :value="user.id"
                            v-for="user in assigneeOptions"
                        >
                        </el-option>
                    </el-select>
                </div>
            </el-col>
        </el-row>
    </vue-scroll>
</template>

<script>
import * as ApprovalStatus from "@/constants/approval-status";
import * as BusEvents from "@/constants/bus-events";
import * as OrderStatuses from "@/constants/order-statuses";
import * as OrderableTypes from "@/constants/orderable-types";
import * as Routes from "@/constants/routes";
import * as ShippingProviders from "@/constants/shipping-providers";
import address_mixin from "@/mixins/address";
import assign_order from "@/mixins/assign-order";
import auth_mixin from "@/mixins/auth";
import order_status_mixin from "@/mixins/order-status";
import FileUtils from "@/utils/file";
import OrderUtils from "@/utils/order";
import AuditLog from "@/views/pages/order/AuditLog";
import Breakdown from "@/views/pages/order/Breakdown";
import Tracking from "@/views/pages/order/Tracking";
import { mapState } from "vuex";
import InvoicePaymentLink from "../../../components/InvoicePaymentLink.vue";
import EditStatus from "./EditStatus";

function getData(id) {
    return axios.get(`/web-api/order/${id}`, {
        params: {
            include:
                "statuses.updater,community.locations,community.address,creator,tenant,latest_status"
        }
    });
}

export default {
    mixins: [order_status_mixin, auth_mixin, address_mixin, assign_order],
    components: {
        InvoicePaymentLink,
        EditStatus,
        Tracking,
        Breakdown,
        AuditLog
    },
    beforeRouteEnter(to, from, next) {
        getData(to.params.id).then((response) => {
            next((vm) => vm.setData(response));
        });
    },
    beforeRouteUpdate(to, from, next) {
        getData(to.params.id).then((response) => {
            this.setData(response);
            next();
        });
    },
    data() {
        return {
            OrderStatuses,
            ApprovalStatus,
            OrderableTypes,
            order: null,
            statuses: null,
            approvalForm: new Form({
                approval_status: null
            }),
            rush_processing: false,
            trackingForm: new Form({
                tracking_number: null
            }),
            billableEditForm: new Form({
                is_billable_edit: true
            }),
            invoicePaidForm: new Form({
                is_paid: false
            }),
            loadingNext: false,
            loadingPrevious: false,
            downloadAllForm: new Form(),
            assignForm: new Form({
                assignee_id: null
            })
        };
    },
    computed: {
        ...mapState({
            workflow: (state) => state.config.settings.workflow
        }),
        approvalDone() {
            return this.order && !!this.order.approval_status;
        },
        isApproved() {
            return OrderUtils.isApproved(this.order);
        },
        formattedAddress() {
            if (!this.order) {
                return null;
            }
            return this.getAddressFullText(this.order.community.address);
        },
        shippingInfo() {
            if (!this.order.custom_shipping_account_number) {
                return "UPS Ground";
            }
            let info = "";
            if (this.order.custom_shipping_account_number) {
                switch (this.order.custom_shipping_provider) {
                    case null:
                    case ShippingProviders.UPS:
                        info = `Via UPS`;
                        break;
                    case ShippingProviders.FEDEX:
                        info = `Via FedEx`;
                        break;
                }
                info += ` using client's account number: ${this.order.custom_shipping_account_number}`;
            }
            return info;
        }
    },
    mounted() {},
    methods: {
        setData(response) {
            this.order = response.data;
            this.trackingForm.tracking_number = this.order.tracking_number;
            this.rush_processing = this.order.rush_processing;
            this.invoicePaidForm.is_paid = !!this.order.paid_at;
            this.assignForm.assignee_id = this.order.assignee_id;
        },
        approval(approve = true) {
            this.approvalForm.approval_status = approve
                ? ApprovalStatus.APPROVED
                : ApprovalStatus.REJECTED;
            window.App.put(
                `/web-api/order/${this.order.id}`,
                this.approvalForm
            ).then(({ data }) => {
                this.$notify.success({
                    message: `Order has been ${
                        approve ? "approved" : "rejected"
                    }.`
                });
                _.extend(this.order, data);
                this.$refs.editStatus.reload();
                if (!approve) {
                    window.Bus.$emit(BusEvents.ORDER_REJECTED, this.order);
                }
            });
        },
        updateAuditLogs() {
            if (this.$refs.auditLog) {
                this.$refs.auditLog.getAuditLogs(
                    _.get(
                        this.$refs.auditLog,
                        "logs.meta.pagination.current_page",
                        1
                    )
                );
            }
        },
        onChangeRushProcessing(e) {
            axios
                .put(`/web-api/order/${this.$route.params.id}`, {
                    rush_processing: e
                })
                .then(() => {
                    this.$notify.success({
                        message: "Changes have been saved."
                    });
                });
        },
        downloadJobTicket() {
            window.open(
                `/web-api/order/${this.order.id}/download-job-ticket`,
                "_blank"
            );
        },
        viewInlineJobTicket() {
            window.open(
                `/web-api/order/${this.order.id}/view-pdf-job-ticket`,
                "_blank"
            );
        },
        viewHtmlJobTicket() {
            window.open(
                `/web-api/order/${this.order.id}/view-html-job-ticket`,
                "_blank"
            );
        },
        downloadAll() {
            this.downloadAllForm.startProcessing();
            axios
                .get(`/web-api/order/${this.order.id}/download-all`, {
                    responseType: "blob"
                })
                .then((response) => {
                    FileUtils.downloadFileFromBlobResponse(response);
                })
                .finally(() => {
                    this.downloadAllForm.finishProcessing();
                });
        },
        downloadLogo() {
            window.open(
                `/web-api/community/${this.order.community_id}/download-logo`,
                "_blank"
            );
        },
        placeOnBillableEdit() {
            this.$confirm(
                "Are you sure you want to place order on billable edit?",
                "Confirmation",
                {
                    confirmButtonText: "OK",
                    cancelButtonText: "Cancel",
                    type: "info"
                }
            )
                .then(() => {
                    App.put(
                        `/web-api/order/${this.order.id}/billable-edit`,
                        this.billableEditForm
                    ).then((response) => {
                        this.$notify.success({
                            message: `Order has been placed on billable edit.`
                        });
                        _.extend(this.order, response.data);
                        this.updateAuditLogs();
                    });
                })
                .catch(() => {
                    //user cancelled
                });
        },
        navigatePlacedPendingOrder(next = true) {
            let loadingProp = `loading${next ? "Next" : "Previous"}`;
            this[loadingProp] = true;
            axios
                .get(
                    `/web-api/order/${this.$route.params.id}/placed-${
                        next ? "next" : "previous"
                    }-pending`
                )
                .then((response) => {
                    if (!response.data.id) {
                        this.$notify.warning({
                            message: `No ${
                                next ? "next" : "previous"
                            } pending order.`
                        });
                        return;
                    }
                    this.$router.push({
                        name: Routes.VIEW_ORDER,
                        params: {
                            id: response.data.id
                        }
                    });
                })
                .finally(() => (this[loadingProp] = false));
        },
        navigateOrder(next = true) {
            let loadingProp = `loading${next ? "Next" : "Previous"}`;
            this[loadingProp] = true;
            axios
                .get(
                    `/web-api/order/${this.$route.params.id}/${
                        next ? "next" : "previous"
                    }-pending`
                )
                .then((response) => {
                    if (!response.data.id) {
                        this.$notify.warning({
                            message: `No ${
                                next ? "next" : "previous"
                            } pending order.`
                        });
                        return;
                    }
                    this.$router.push({
                        name: Routes.VIEW_ORDER,
                        params: {
                            id: response.data.id
                        }
                    });
                })
                .finally(() => (this[loadingProp] = false));
        },
        navigateClosedOrder(next = true) {
            let loadingProp = `loading${next ? "Next" : "Previous"}`;
            this[loadingProp] = true;
            axios
                .get(
                    `/web-api/order/${this.$route.params.id}/${
                        next ? "next" : "previous"
                    }-closed`
                )
                .then((response) => {
                    if (!response.data.id) {
                        this.$notify.warning({
                            message: `No ${
                                next ? "next" : "previous"
                            } pending order.`
                        });
                        return;
                    }
                    this.$router.push({
                        name: Routes.VIEW_ORDER,
                        params: {
                            id: response.data.id
                        }
                    });
                })
                .finally(() => (this[loadingProp] = false));
        },
        editInvoiceLines() {
            this.$router.push({
                name: Routes.EDIT_ORDER_INVOICE_LINES,
                params: {
                    id: this.order.id
                }
            });
        },
        viewInvoice() {
            OrderUtils.openInvoicePdf(this.order);
        },
        viewSageInvoice() {
            OrderUtils.openSageInvoicePdf(this.order);
        },
        onChangeInvoicePaid() {
            App.put(
                `/web-api/order/${this.order.id}`,
                this.invoicePaidForm
            ).then((response) => {
                this.$notify.success({
                    message: "Changes have been saved."
                });
                _.extend(this.order, _.pick(response.data, ["paid_at"]));
            });
        },
        onChangeAssignee() {
            App.put(`/web-api/order/${this.order.id}`, this.assignForm).then(
                (response) => {
                    if (response.data.assignee_id) {
                        let user = _.find(this.assigneeOptions, {
                            id: response.data.assignee_id
                        });
                        this.$notify.success({
                            message: `Job has been assigned to ${user.name}.`
                        });
                    } else {
                        this.$notify.success({
                            message: "Job has been unassigned."
                        });
                    }
                }
            );
        },
        getInvoicedStatus(statuses) {
            var result = statuses.find((obj) => {
                return obj.status === "invoiced";
            });
            if (result && result.checked == true) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>
